
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export interface Profile {
  id: string;
  username: string | null;
  is_admin: boolean;
  created_at: string;
  verification_status: 'none' | 'pending' | 'verified' | 'rejected';
  has_verified_email: boolean;
  is_creative: boolean;
}

export async function fetchUserProfiles() {
  const { data, error } = await supabase
    .from('profiles')
    .select('*')
    .order('created_at', { ascending: false });

  if (error) throw error;
  return data;
}

export async function updateUserRole(userId: string, makeAdmin: boolean) {
  // Update the profiles table with the new admin status
  const { data, error } = await supabase
    .from('profiles')
    .update({ is_admin: makeAdmin })
    .eq('id', userId);

  if (error) {
    console.error("Error updating user role:", error);
    throw error;
  }
  
  // Return the updated data
  return data;
}

export async function updateUserVerification(userId: string, status: 'none' | 'verified' | 'verified_creative') {
  const updates = {
    verification_status: status === 'verified_creative' ? 'verified' : status,
    is_creative: status === 'verified_creative'
  };

  const { error } = await supabase
    .from('profiles')
    .update(updates)
    .eq('id', userId);

  if (error) {
    console.error("Error updating user verification:", error);
    throw error;
  }
}

export async function deleteUser(userId: string) {
  // Using the RPC function to delete a user
  const { error } = await supabase
    .rpc('delete_user', { user_id: userId });
    
  if (error) {
    console.error("Error deleting user:", error);
    throw error;
  }
}

export async function checkAdminStatus(userId: string) {
  const { data, error } = await supabase
    .from('profiles')
    .select('is_admin')
    .eq('id', userId)
    .single();

  if (error) throw error;
  return data.is_admin;
}

export async function getFirstAdmin() {
  const { data, error } = await supabase
    .from('profiles')
    .select('id')
    .eq('is_admin', true)
    .order('created_at', { ascending: true })
    .limit(1)
    .single();

  if (error) throw error;
  return data;
}
